import { LoginRequestBody, RefreshTokenRequestBody } from "../../common/model/login/requestBody";
import { LoginResponseBody, RefreshTokenResponseBody } from "../../common/model/login/responseBody";
import { LOGIN_API_Parameter, REFRESH_TOKEN_Parameter } from "../apiParameters";
import { baseResponseBody } from "../objectTypeConstants";

export const loginRequestBody: LoginRequestBody = {
    email: LOGIN_API_Parameter.email,
    password: LOGIN_API_Parameter.password,
}

export const loginResponseBody: LoginResponseBody = {
    ...baseResponseBody,
    data: {
        accessToken: LOGIN_API_Parameter.accessToken,
        expiresIn: LOGIN_API_Parameter.expiresIn,
        tokenType: LOGIN_API_Parameter.tokenType,
        refreshToken: LOGIN_API_Parameter.refreshToken,
    }
};

export const refreshTokenRequestBody: RefreshTokenRequestBody = {
    refreshToken: REFRESH_TOKEN_Parameter.refreshToken,
}

export const refreshTokenResponseBody: RefreshTokenResponseBody = {
    ...baseResponseBody,
    data: {
        accessToken: LOGIN_API_Parameter.accessToken,
        expiresIn: LOGIN_API_Parameter.expiresIn,
        tokenType: LOGIN_API_Parameter.tokenType,
        refreshToken: LOGIN_API_Parameter.refreshToken,
    }
}